/**
 * @file BlogScreenStructure.tsx
 * @description Структура экрана «Блог» (phase19.16 Р2; uiux-design-r2 §8;
 * SB40, SB103): Шапка · [блоки над лентой] · «Лента статей — вид в панели
 * «Блог»» (закреплённая строка) · [блоки под лентой] · Подвал, ниже —
 * «Под каждой статьёй». Блок открывается на странице своего места (там их
 * правят, двигают и добавляют тем же «+ Добавить блок»).
 */

import { siteSlotsFor } from "@chaiberi/shared";

import { useBuilder } from "../builder-context";
import { AreaRow } from "./AreaRow";
import { LockedScreenRow } from "./LockedScreenRow";
import { SlotGroup } from "./SlotGroup";
import { useScreenSlots } from "../../../hooks/site-builder/useScreenSlots";

export function BlogScreenStructure() {
  const b = useBuilder();
  const api = useScreenSlots(b.canEditPages);
  // Места экрана по реестру shared: над лентой, под лентой, под статьёй.
  const [above, below, article] = siteSlotsFor("blog");
  return (
    <div className="flex flex-col gap-1">
      <AreaRow area="header" selected={b.selection.sel.kind === "area" && b.selection.sel.area === "header"} />
      {api.error ? <p className="type-caption px-3 text-on-surface-variant">Не удалось загрузить блоки блога — проверьте связь.</p> : null}
      {above ? <SlotGroup slotKey={above.key} api={api} /> : null}
      <LockedScreenRow label="Лента статей — вид в панели «Блог»" onOpen={() => void b.select({ panel: "blog" })} />
      {below ? <SlotGroup slotKey={below.key} api={api} /> : null}
      <AreaRow area="footer" selected={b.selection.sel.kind === "area" && b.selection.sel.area === "footer"} />
      <span className="type-caption px-3 pt-3 text-on-surface-variant">На странице каждой статьи</span>
      {article ? <SlotGroup slotKey={article.key} api={api} /> : null}
    </div>
  );
}
